import { Button } from '@britishcouncil/react-admin';
import { Modal } from 'semantic-ui-react';
import { Link, generatePath } from 'react-router';
import { ROUTING_PATHS } from 'const';

type Props = {
  isSaving: boolean;
  saved: boolean;
  sessionId: number;
  disabled: boolean;
};

export const Footer = ({ isSaving, saved, sessionId, disabled }: Props) => {
  const { lrwSessionDetails } = ROUTING_PATHS;

  return (
    <Modal.Actions>
      <Link to={generatePath(lrwSessionDetails.absolutePath, { sessionId })}>
        <Button compact type="reset" secondary>
          Cancel
        </Button>
      </Link>

      <Button
        compact
        color="blue"
        type='submit'
        disabled={disabled || isSaving || saved}
        loading={isSaving}
      >
        Confirm
      </Button>
    </Modal.Actions>
  );
};
